// src/components/ProductCard/ProductCard.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product }) => {
    const navigate = useNavigate();

    // Default: first variant
    const [selectedVariant, setSelectedVariant] = useState(
        product.variants && product.variants.length > 0 ? product.variants[0] : null
    );

    // Use selected variant's first image or product.media[0]
    let mainImage =
        selectedVariant && selectedVariant.images && selectedVariant.images.length > 0
            ? selectedVariant.images[0].url
            : (product.media && product.media.length > 0 ? product.media[0].url : null);

    // Use variant price if present, otherwise product.price
    const price = selectedVariant?.price || product.price;
    // For demo, MRP as price + 900 (You can update based on your data model)
    const mrp = price + 900;

    return (
        <div
            className="border rounded-xl shadow hover:shadow-xl transition-all bg-white flex flex-col items-center p-4 cursor-pointer"
            onClick={() => navigate(`/product/${product.id}`)}
        >
            {/* Product Main Image */}
            <div className="w-full flex items-center justify-center mb-2 min-h-[180px]">
                {mainImage ? (
                    <img
                        src={mainImage}
                        alt={product.name}
                        className="h-48 w-auto max-w-full object-contain rounded"
                    />
                ) : (
                    <div className="text-gray-400">No image</div>
                )}
            </div>
            {/* Product Name */}
            <div className="font-bold text-base text-center line-clamp-2 mb-1">{product.name}</div>
            {/* Price Row */}
            <div className="flex items-baseline gap-2 mb-1">
                <span className="text-orange-600 font-bold text-lg">₹{price.toFixed(2)}</span>
                <span className="text-gray-400 line-through text-sm">₹{mrp.toFixed(2)}</span>
            </div>
            {/* Variant Swatches (images for color) */}
            {product.variants && product.variants.length > 0 && (
                <div className="flex flex-wrap items-center gap-2 mt-1 mb-2">
                    {product.variants.map(variant => (
                        <button
                            key={variant.id}
                            className={`w-8 h-8 border-2 rounded overflow-hidden bg-white p-0.5 ${selectedVariant && selectedVariant.id === variant.id ? "border-orange-500 ring-2 ring-orange-200" : "border-gray-300"}`}
                            style={{ outline: 'none' }}
                            onClick={e => {
                                e.stopPropagation();
                                setSelectedVariant(variant);
                            }}
                            aria-label={variant.color}
                            title={variant.color}
                        >
                            {variant.images && variant.images.length > 0 ? (
                                <img
                                    src={variant.images[0].url}
                                    alt={variant.color}
                                    className="w-full h-full object-contain"
                                />
                            ) : (
                                <div
                                    className="w-full h-full"
                                    style={{ background: variant.colorHex || variant.color }}
                                ></div>
                            )}
                        </button>
                    ))}
                </div>
            )}
            <div className="text-xs text-gray-500 font-medium">Available Colors</div>
        </div>
    );
};

export default ProductCard;
